import {createActionGroup, props} from '@ngrx/store';
import {ProductManagementErrorInterface} from '../../../error/error-handling/product-management-error';
import {ProductQueryParams} from '../../../models';
import {PagedApiResponse, Product} from '../../../models/clare';

export const ProductListActions = createActionGroup({
  source: 'Product List',
  events: {
    'Toggle Product Active Status': props<{productId: string; active: boolean}>(),
    'Toggle Product Active Status Success': props<{product: Product}>(),
    'Toggle Product Active Status Failure': props<{error: ProductManagementErrorInterface}>(),
    'Load Products': props<{queryParams: ProductQueryParams}>(),
    'Load Products Success': props<{products: PagedApiResponse<Product>}>(),
    'Load Products Failure': props<{error: ProductManagementErrorInterface}>(),
    'Load Products For Selection': props<{queryParams: ProductQueryParams}>(),
    'Load Products For Selection Success': props<{products: PagedApiResponse<Product>}>(),
    'Load Products For Selection Failure': props<{error: ProductManagementErrorInterface}>(),
    'Set Clare Account Status': props<{clareAccountStatus: string}>(),
  },
});
